<template>
  <div :class="`wrap wrap_${auth.serviceLang}`">
    <Header></Header>
    <Content></Content>
    <Footer></Footer>
  </div>
</template>
<script>
  import { rootComputed } from '@/store/helpers'
  import Header from '@/layout/Header'
  import Content from '@/layout/Content'
  import Footer from '@/layout/Footer'

  export default {
    components: {
      Content,
      Header,
      Footer
    },
    computed: {
      ...rootComputed
    },
    methods: {
    }
  }

</script>

<style>

</style>
